import styled from '@emotion/styled'
import { IconButton, Box } from '@mui/material'

export const ActionsContainer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
`

export const StyledIconButton = styled(IconButton)`
  padding: 0px;
`

export const TableContainer = styled(Box)`
  padding: 0 8px;
  overflow: auto;
`
